// src/Context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [token, setToken] = useState(() => Cookies.get('token') || null);

    useEffect(() => {
        if (token) {
            Cookies.set('token', token, { secure: true, sameSite: 'Strict' });
        } else {
            Cookies.remove('token');
        }
    }, [token]);

    // Add logout method to clear token
    const logout = () => {
        setToken(null);
    };

    return (
        <AuthContext.Provider value={{ token, setToken, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
